// extracted by mini-css-extract-plugin
export var modal = "_dg-0";